import { useEffect, useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";


const CategoriaSlider = (props) => {
    const { categorias, nombre, seleccionado, search } = props;
    const [desplazamiento, setDesplazamiento] = useState(0);
    const [rightLimit, setRightLimit] = useState(0)
    let history = props.history;


    
    const obtainWidth = (section) => {
        const width = document.getElementsByClassName(section);
        const pxtorem = ((width[0].scrollWidth - width[0].clientWidth) * 0.06);
        setRightLimit(Math.trunc(pxtorem) + 3);
    }

    const handleClick = (e, prop, seccion, title = "") => {
        let newUrl = `/Catalogo/Categoria/${prop}/${title}${('Todos' === title & search != null) ? "/" + search : ""}`
        history.push(newUrl + "/1");
    }

    const handlePrev = () => {
        (desplazamiento + 15 == 0 || desplazamiento + 15 < 0)
            ?
            setDesplazamiento(desplazamiento + 15)
            :
            setDesplazamiento(0);
    }

    const handleNext = () => {
        (desplazamiento - 15 > -rightLimit)
            ?
            setDesplazamiento(desplazamiento - 15)
            :
            setDesplazamiento(-rightLimit);
    }

    useEffect(() => {
        obtainWidth("filtros-categorias-items");
    }, [categorias])

    return (
        <div className="filtros-categorias">
            <div className="filtros-categorias-icono" onClick={handlePrev}>
                <i id="izquierda" className="fas fa-chevron-left"></i>
            </div>

            <ScrollContainer className="filtros-categorias-items" horizontal={true} hideScrollbars={true} nativeMobileScroll={true}>
                <div
                    className="filtros-categorias-items-contenedor"
                    style={
                        {
                            left: desplazamiento + "rem",
                            transition: "1s"
                        }
                    }
                >
                    <button
                        className={(seleccionado.includes("-") || nombre == "Marcas") ? "seleccionado" : ""}
                        onClick={
                            (e) => {
                                handleClick(e, -1, ".filtros-categorias-items", "Todos")
                            }
                        }
                    >
                        Todos
                    </button>
                    {
                        categorias
                            .sort((c1, c2) => c1.orden - c2.orden)
                            .map(
                                (c, i) => {
                                    return (
                                        <button
                                            key={i + c.titulo}
                                            className={seleccionado == c.id ? "seleccionado" : ""}
                                            onClick={
                                                (e) => {
                                                    handleClick(e, c.id, ".filtros-categorias-items", c.titulo)
                                                }
                                            }
                                        >
                                            {c.titulo}
                                        </button>
                                    )
                                }
                            )
                    }
                </div>
            </ScrollContainer>

            <div className="filtros-categorias-icono" onClick={handleNext}>
                <i id="derecha" className="fas fa-chevron-right"></i>
            </div>
        </div>
    )
}
export default CategoriaSlider;